/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: collab.fga
 * Run: pnpm run gen:permissions -- collab
 */

import type { ModulePermissions } from './types';

export const collabPermissions = {
  module: 'collab',
  displayName: 'Collab',
  entities: [
    {
      name: 'contacts',
      displayName: 'Contacts',
      permissions: [{ key: 'contactsRead', action: 'Read', category: 'crud' }],
    },
    {
      name: 'conversation',
      displayName: 'Conversation',
      permissions: [
        { key: 'conversationRead', action: 'Read', category: 'crud' },
        { key: 'conversationReadAny', action: 'Read Any', category: 'custom' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Collab module
 */
export type CollabPermissionKey =
  | 'contactsRead'
  | 'conversationRead'
  | 'conversationReadAny';
